import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { IndexadorCreateOrUpdateRequest } from "../typings";

const getRoute = (id: string) => `/v1/indexador/${id}/`;
function useEditIndexador() {
  const queryClient = useQueryClient();

  return useMutation(
    "edit/v1/indexador/:id",
    ({ id, data }: { id: string; data: IndexadorCreateOrUpdateRequest }) =>
      http.put(getRoute(id), data),
    {
      retry: false,
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries([getRoute(id), "/v1/indexador"]);
      },
      onError: (e) => {
        showErrorAxios(e)
      }
    }
  );
}

export default useEditIndexador;
